import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {SaveEstimateRequest} from "../types/SaveEstimateRequest";
import {SaveEstimateResult} from "../types/SaveEstimateResult";

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useSaveEstimate = (
	params: SaveEstimateRequest,
	onSuccess: (result: SaveEstimateResult) => void,
	onError: (error: string) => void
) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post('/ee-pro/save-estimate', params) as SaveEstimateResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when save estimate: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
